import axios from "../plugins/parseAxios";

export class QRPaymentReportAPI {
  static getQRPaymentReportBetweenDateByMarket(marketId, startDate, endDate) {
    return axios.post("functions/getQRPaymentReportBetweenDateByMarket", {
      marketId,
      startDate,
      endDate,
    });
  }
  static getQRPaymentReportBetweenDateByProject(formData) {
    return axios.post("functions/getQRPaymentReportBetweenDateByProject", formData);
  }
}